export default
'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 85 85" xml:space="preserve">' +
'<path d="M42.5,0C19,0,0,19,0,42.5S19,85,42.5,85S85,66,85,42.5S66,0,42.5,0z M65,66H53.6V31h-0.1L46.9,66h-8.8L31.6,31h-0.1V66H20' +
'V19h17.5l4.9,27.9h0.1L47.5,19H65V66z"/>' +
'</svg>';
